<template>
    <v-container>
        <v-toolbar dense flat color="transparent">
            <v-toolbar-title class="font-weight-bold">Forms</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-row>
            <v-col cols="4">
                <v-form ref="createForm">
                    <v-card>
                        <v-card-text>
                            <div class="subtitle-2">Form Name</div>
                            <v-text-field
                                v-model="newItem.title"
                                required
                                :rules="[(v) => !!v || 'This is required']"
                                outlined
                                hide-details="auto"
                                dense
                            ></v-text-field>
                        </v-card-text>
                        <v-card-text>
                            <div class="subtitle-2">Venue</div>
                            <v-text-field
                                v-model="newItem.venue"
                                outlined
                                hide-details="auto"
                                dense
                            ></v-text-field>
                        </v-card-text>
                        <v-card-text>
                            <div class="subtitle-2">Event</div>
                            <v-select
                                v-model="newItem.event_id"
                                :items="events"
                                required
                                :rules="[(v) => !!v || 'This is required']"
                                dense
                                outlined
                                hide-details="auto"
                                item-text="name"
                                item-value="id"
                            ></v-select>
                        </v-card-text>
                        <v-card-text>
                            <div class="subtitle-2">Start Date</div>
                            <v-menu
                                ref="startDateMenu"
                                v-model="startDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="startDateFormatted"
                                        dense
                                        outlined
                                        persistent-hint
                                        hide-details="auto"
                                        v-bind="attrs"
                                        @blur="
                                            newItem.valid_from = parseDate(
                                                startDateFormatted
                                            )
                                        "
                                        v-on="on"
                                        required
                                        :rules="[(v) => !!v || 'This is required']"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="newItem.valid_from"
                                    no-title
                                    @input="startDateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-card-text>
                        <v-card-text>
                            <div class="subtitle-2">End Date</div>
                            <v-menu
                                ref="endDateMenu"
                                v-model="endDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="endDateFormatted"
                                        dense
                                        outlined
                                        persistent-hint
                                        hide-details="auto"
                                        v-bind="attrs"
                                        @blur="
                                            newItem.valid_to = parseDate(
                                                endDateFormatted
                                            )
                                        "
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="newItem.valid_to"
                                    no-title
                                    @input="endDateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="lime darken-4" @click="onSubmit"
                                >New Form</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
            <v-col cols="8">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :items-per-page="10"
                    :loading="loading"
                    :options.sync="tableOptions"
                    :server-items-length="totalItems"
                    :sort-by="defaultOrdering.column"
                    :sort-desc="defaultOrdering.descending"
                    multi-sort
                    class="elevation-1"
                >
                    <template v-slot:item="row">
                        <tr
                            class="tm-pointer"
                            @click="
                                $router.push(
                                    '/feedback-tool/forms/' + row.item.id
                                )
                            "
                        >
                            <td>
                                <v-checkbox></v-checkbox>
                            </td>
                            <td>{{ row.item.title }}</td>
                            <td>{{ row.item.event.name }}</td>
                            <td>
                                {{
                                    $moment(row.item.valid_from).format(
                                        "DD-MM-YYYY"
                                    )
                                }}
                            </td>
                            <td>
                                {{
                                    $moment(row.item.valid_to).format(
                                        "DD-MM-YYYY"
                                    )
                                }}
                            </td>
                            <td>
                                {{
                                    $moment(row.item.created_at).format(
                                        "DD-MM-YYYY HH:mm:ss"
                                    )
                                }}
                            </td>
                            <td>
                                {{
                                    $moment(row.item.updated_at).format(
                                        "DD-MM-YYYY HH:mm:ss"
                                    )
                                }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data: (vm) => ({
        modelPath: "feedback-tool/form",
        newItem: {
            title: "",
            event_id: "",
            venue: "",
            valid_from: null,
            valid_to: null,
        },
        startDateFormatted: null,
        endDateFormatted: null,
        startDateMenu: false,
        endDateMenu: false,
        events: [],
        tableOptions: {},
        totalItems: 0,
        headers: [
            {
                text: "",
                value: "",
            },
            {
                text: "Form Name",
                value: "title",
            },
            {
                text: "Event",
                value: "event.name",
            },
            {
                text: "Start Date",
                value: "start_date",
            },
            {
                text: "End Date",
                value: "end_date",
            },
            {
                text: "Created At",
                value: "created_at",
            },
            {
                text: "Updated At",
                value: "updated_at",
            },
        ],
        defaultOrdering: {
            column: ["created_at"],
            descending: [true],
        },
        items: [],
        loading: false,
    }),
    computed: {
        ordering() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
            let ordering = "";
            if (sortBy)
                sortBy.forEach((val, index, arr) => {
                    ordering += ordering ? "," : "";
                    ordering += (sortDesc[index] ? "-" : "") + val;
                });
            return ordering;
        },
        computedStartDateFormatted() {
            return this.formatDate(this.newItem.valid_from);
        },
        computedEndDateFormatted() {
            return this.formatDate(this.newItem.valid_to);
        },
    },
    watch: {
        tableOptions: {
            handler() {
                this.getListOfItems().then((data) => {
                    this.items = data.items;
                    this.totalItems = data.total;
                    this.loading = false;
                });
            },
            deep: true,
        },
        "newItem.valid_from"(val) {
            this.startDateFormatted = this.formatDate(this.newItem.valid_from);
        },
        "newItem.valid_to"(val) {
            this.endDateFormatted = this.formatDate(this.newItem.valid_to);
        },
    },
    created() {
        this.getListOfItems().then((data) => {
            this.items = data.items;
            this.totalItems = data.total;
            this.loading = false;
        });
        this.getListOfDepartments().then((data) => {
            this.events = data.items;
            this.loading = false;
        });
    },
    methods: {
        onSubmit: function () {
            if (this.$refs.createForm.validate()) {
                //TODO :- Perform action if the form is validated

                this.postCreateNewItem().then((res) => {
                    this.items.push(res.data);
                    this.$refs.createForm.reset();
                });
            }
        },
        getListOfDepartments: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "get",
                    url: `/feedback-tool/event`,
                })
                    .then(function (response) {
                        console.log(response.data);
                        let items = response.data.results;
                        resolve({
                            items,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
        getListOfItems: function () {
            return new Promise((resolve) => {
                const {
                    sortBy,
                    sortDesc,
                    page,
                    itemsPerPage,
                } = this.tableOptions;
                this.loading = true;

                this.$http({
                    method: "get",
                    url: `/${this.modelPath}`,
                    params: {
                        page: page,
                        itemsPerPage: itemsPerPage,
                        ordering: this.ordering,
                    },
                })
                    .then(function (response) {
                        console.log(response.data);
                        let items = response.data.results;
                        const total = response.data.count;
                        resolve({
                            items,
                            total,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
        postCreateNewItem: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "post",
                    url: `/${this.modelPath}/`,
                    data: this.newItem,
                })
                    .then(function (response) {
                        console.log(response.data);
                        let data = response.data;
                        resolve({
                            data,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            var originalDate = this.$moment(date, "DD-MM-YYYY");
            var formattedDate = originalDate.format("YYYY-MM-DD");
            return formattedDate;
        },
    },
};
</script>
